/** Junta classes ignorando falsy. Existe para não espalhar template string com
 *  condicional por todo componente — e para o `className` continuar legível. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
